import React from 'react'
import styles from './HostingAdvantages.scss'

import ComponentServicesFeaturesTable
	from '../../../components/ComponentServicesFeaturesTable/ComponentServicesFeaturesTable'

import icon1 from './img/advantages-support.svg'
import icon2 from './img/advantages-clients.svg'
import icon3 from './img/advantages-traphic.svg'
import icon4 from './img/advantages-defence.svg'
import icon5 from './img/advantages-ddos.svg'
import icon6 from './img/advantages-ssd.svg'
import {__t} from '../../../common/lang/text-resource'

const HostingAdvantages = () => {
	return (
	  <>
		  <section className={styles.container}>
			  <div className={styles.iconsContainerInner}>
				  <div className={styles.iconContainer}>
					  <div className={styles.icon}>
						  <img src={icon1} alt={__t('Денонощна поддръжка')}/>
						  <span>
				{__t('Денонощна')} <br/>
							  {__t('поддръжка')}
              </span>
					  </div>
				  </div>
				  <div className={styles.iconContainer}>
					  <div className={styles.icon}>
						  <img src={icon2} alt={__t('Безупречно клиентско обслужване')}/>
						  <span>
				{__t('Безупречно')} <br/>
							  {__t('клиентско')} <br/>
							  {__t('обслужване')}
              </span>
					  </div>
				  </div>
				  <div className={styles.iconContainer}>
					  <div className={styles.icon}>
						  <img src={icon3} alt={__t('Неограничен трафик')}/>
						  <span>
				{__t('Неограничен')} <br/>
							  {__t('трафик')}
              </span>
					  </div>
				  </div>
				  <div className={styles.iconContainer}>
					  <div className={styles.icon}>
						  <img src={icon4} alt={__t('Цялостна защита от хакерски атаки')}/>
						  <span>
				{__t('Цялостна защита от')} <br/>
							  {__t('хакерски атаки')}
              </span>
					  </div>
				  </div>
				  <div className={styles.iconContainer}>
					  <div className={styles.icon}>
						  <img src={icon5} alt={__t('DDoS защита')}/>
						  <span>{__t('DDoS защита')}</span>
					  </div>
				  </div>
				  <div className={styles.iconContainer}>
					  <div className={styles.icon}>
						  <img src={icon6} alt={__t('All SSD за СуперСкорост')}/>
						  <span>
				{__t('All SSD за')}
							  <br/> {__t('СуперСкорост')}
              </span>
					  </div>
				  </div>
			  </div>
			  <div className={styles.featuresContainer}>
				  <ComponentServicesFeaturesTable displayRenewPricesInTable={true}/>
			  </div>
		  </section>
	  </>
	)
}

export default HostingAdvantages